import { call, put, takeLatest } from "@redux-saga/core/effects";
import { ALERTS_ACTION, errorAlertsListAction, responseAlertListAction } from "./AlertsActionCreator";
import AlertsService from "../../Services/RestApiManager/AlertsManager/AlertsService";

export function* alertsListRequest(action) {
    try {
      const response = yield call(AlertsService.shared.alertsListRequest, action.data);
      yield put(responseAlertListAction(response));
    } catch (error) {
      yield put(errorAlertsListAction(error));
    }
  }


export function* alertsWatcherSaga() {
    yield takeLatest(ALERTS_ACTION.REQUEST_ALERTS_LIST, alertsListRequest);
  }